import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { ModalComponent } from "@app/shared/components";
import { TreeModel } from "@app/shared/components/tree/tree.model";
import { TreeAdapter } from "@app/shared/util/tree-adapter.utils";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-document-tree-modal',
    templateUrl: './document-tree-modal.component.html',
    styleUrls: ['./document-tree-modal.component.scss']
  })
  export class DocumentTreeModalComponent implements OnInit {
    _logger = Log.create(DocumentTreeModalComponent.name);

    @Output() onUpdate: EventEmitter<any> = new EventEmitter();

    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent; _items = [];
    @Input() displayField: string;
    @Input() label = '';
    @Input() labelClass = {};
    @Input() hasContextMenu = false;
    @Input() contextMenuItems = [];
    @Input() toolId: number;
    @Input() hasRootPath: boolean;

    isLoading: boolean;

    type: string;
    selectedNodes: TreeModel[] = [];
    constructor(private treeAdapter: TreeAdapter) {
    }

    ngOnInit(): void {
    }

    get items() {
        return this._items;
    }

    @Input()
    set items(items) {
        this._items = this.treeAdapter.adaptDocumentsToTree(items, this.displayField);
    }

    open(data: any, type: string) {
        this.modal.open();

        this.isLoading = true;

        this._items = this.treeAdapter.adaptDocumentLocationsToTree(data, 'name');
        this.flatten(this.selectedNodes, this._items);
        this.type = type;

        this.isLoading = false;
    }

    close() {
        this.isLoading = false;
        this.selectedNodes = [];
        this.modal.close();
    }

    updatePath() {
        this.processData(this.selectedNodes);
    }

    processData(data: TreeModel[]) {
        this.isLoading = true;
        const listOfPaths = data.map(x => x.fullPath);
        this.onUpdate.emit( {toolId: this.toolId, listOfPaths: listOfPaths, type: this.type});
    }

    flatten(destArray, nodeList) {
        nodeList.forEach((node) => {
            if (node.isSelected) {
                destArray.push(node);
            }
          this.flatten(destArray, node.children || []);
        });
      }
}
